<template>
  <div class="quick-view-form">
    <div v-if="obMessages" class="quick-view-form__text">
      {{ obMessages.quickBuy }}
    </div>

    <form class="quick-view-form__form def-validation" @submit.prevent="handlerSubmitForm">
      <DefPhone name="phone" required @input="changeColor" />
      <!--      <input-->
      <!--        type="text"-->
      <!--        class="def-input def-tel-mask"-->
      <!--        name="phone"-->
      <!--        placeholder="+38 (XXX) XXX XX XX"-->
      <!--        required-->
      <!--        @input="changeColor"-->
      <!--      />-->
      <button
        v-if="obMessages"
        type="submit"
        class="def-button"
        :class="{ 'active-button': activeBtn }"
      >
        {{ obMessages.buyOneClick }}
      </button>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ThanksForApplication from '@components/Catalog/modal/ThanksForApplication.vue';
import useModal from '@use/useModal/useModal';
import DefPhone from '@components/Def/DefPhone/DefPhone.vue';
import Analytics from '../../utils/Analytics';
import Recaptcha3 from '../../utils/Recaptcha3';

export default {
  name: 'QuickViewForm',
  components: { DefPhone },
  props: ['messages', 'intoBasket', 'dataLayer'],
  data() {
    return {
      activeBtn: false,
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      productMessages: ({ product }) => product.data?.messages,
      basketPrices: ({ basket }) => basket.data?.price,
      product: ({ product }) => product.data?.product,
    }),
    ...mapGetters({
      productId: 'product/id',
    }),
    // id() {
    //     if (Array.isArray(this.product)) {
    //         for (let item in this.product) {
    //             return this.product[item].offer?.id || this.product[item].item.id;
    //         }
    //     }
    //     return this.product?.offer?.id || this.product?.id;
    // },
    obMessages() {
      return this?.productMessages ?? this.messages;
    },
  },
  methods: {
    ...mapActions({
      basketAdd: 'basket/add',
      basketCreateOrderByOneClick: 'basket/createOrderByOneClick',
    }),
    changeColor({ target }) {
      if (target.value.slice(-1) >= 0) {
        this.activeBtn = true;
      } else {
        this.activeBtn = false;
      }
    },
    async handlerSubmitForm({ target }) {
      const formData = new FormData(target);
      const phone = formData.get('phone')?.replace(/[+| |(|)]/g, '');

      const token = await Recaptcha3.getSubmitToken();
      // if (!this.intoBasket) {
      //     await this.basketAdd(this.id);
      // }

      // if (this.intoBasket) {
      //     Analytics.buyOneClick(Object.values(this.dataLayer.data), this.basketPrices);
      // }

      const responseData = await this.basketCreateOrderByOneClick({
        phone,
        'g-recaptcha-response': token,
        saveBasket: 'Y',
        productId: this.productId,
      });
      this.modal.hide();

      this.showThanks(responseData);

      const { product } = responseData;
      if (product) {
        const items = !this.intoBasket
          ? [{ ...this.dataLayer }]
          : Object.values(this.dataLayer.data);

        Analytics.buyOneClick(items, {
          transaction_id: product.ORDER_ID,
          affiliation: 'Online Store Love You',
          value: product.ORDER_PRICE,
          // tax: "4.90",
          shipping: product.SHIPPING_PRICE,
          currency: product.CURRENCY,
          // coupon: "SUMMER_SALE",
        });
      }
    },
    showThanks(data) {
      if (data.product !== undefined) {
        fbq('track', 'Purchase', { value: data.product.PRICE, currency: 'UAH' });
      } else {
        console.log('empty data');
      }
      this.modal.show(
        ThanksForApplication,
        {
          result: data?.messages,
          messages: this.obMessages,
        },
        { width: '368px' }
      );
    },
    // async getDataForPopup() {
    //     try {
    //         if (!this.messages) {
    //             const response = await axios(this.product?.detailPage, {params: {api: 'Y'}});
    //             if (response.status === 200) {
    //                 this.obData = response.data;
    //             }
    //         } else {
    //             this.obData.messages = this.messages;
    //         }
    //
    //     } catch (err) {
    //         console.error(err);
    //     }
    // },
  },
  // created() {
  //     this.getDataForPopup();
  // },
  mounted() {
    // ципляем маску для инпута телефона
    $('body').trigger('init-form');
  },
};
</script>

<style lang="scss" scoped>
.quick-view-form {
  display: flex;
  flex-direction: column;
  background: #f7f8f9;
  padding-left: 20px;
  padding-right: 20px;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

  @include point-md {
    flex-direction: row;
    justify-content: space-between;
  }

  &__text {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: rem(16);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #191918;
    height: 80px;
    margin-right: 20px;

    @include point-md {
      width: 45%;
    }
    @include point-lg {
      width: auto;
    }
  }

  &__form {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: auto;

    @include point-md {
      height: 80px;
      flex-direction: row;
    }

    :deep(.def-phone) {
      //display: block;
      height: 48px;
      flex-grow: 1;
      //margin-bottom: 0;
      @include point-lg {
        width: auto;
      }
    }
    :deep(.def-phone__input) {
      height: 48px;
    }
  }

  .def-button {
    font-weight: 500;
    font-size: rem(14);
    width: 100%;
    margin-right: 0;
    margin-top: 10px;
    text-transform: uppercase;
    color: var(--text-colour-secondary);
    background: #b8d9ec;
    height: 48px;
    flex-shrink: 0;

    &.active-button {
      color: #fff;
      background-color: var(--border-colour-primary);

      &:hover {
        color: #fff;
      }
    }

    @include point-md {
      width: auto;
      margin-top: 0;
    }

    &:hover {
      color: var(--text-colour-secondary);
    }
  }
}
</style>
